var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockUnSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5006C25 19.404 19.4035 25.0006 12.5 25.0006C5.59654 25.0006 0 19.4046 0 12.5006C0 12.0073 0.399554 11.6077 0.892857 11.6077C1.38616 11.6077 1.78571 12.0073 1.78571 12.5006C1.77679 18.4269 6.5731 23.2383 12.4994 23.2472C18.4258 23.2562 23.2372 18.4598 23.2461 12.5335C23.255 6.60716 18.4587 1.79578 12.5324 1.78685C10.4185 1.7835 8.351 2.40459 6.58929 3.572H7.14286C7.63616 3.572 8.03571 3.97156 8.03571 4.46486C8.03571 4.95816 7.63616 5.35772 7.14286 5.35772H4.46429C3.97098 5.35772 3.57143 4.95816 3.57143 4.46486V1.78629C3.57143 1.29299 3.97098 0.893432 4.46429 0.893432C4.95759 0.893432 5.35714 1.29299 5.35714 1.78629V2.24499C11.0195 -1.70088 18.8092 -0.309693 22.7556 5.3527C24.2171 7.44979 25.0006 9.94477 25 12.5006ZM15.6741 13.5435L13.3929 12.0229V8.03629C13.3929 7.54298 12.9933 7.14343 12.5 7.14343C12.0067 7.14343 11.6071 7.54298 11.6071 8.03629V12.5006C11.6071 12.7991 11.7561 13.0776 12.0045 13.2433L14.683 15.029C15.0932 15.3025 15.6479 15.192 15.9213 14.7818C16.1948 14.3717 16.0843 13.817 15.6741 13.5435ZM20.5357 12.5006C20.5357 8.06252 16.9381 4.46486 12.5 4.46486C8.06194 4.46486 4.46429 8.06252 4.46429 12.5006C4.46429 16.9386 8.06194 20.5363 12.5 20.5363C16.9358 20.5313 20.5307 16.9364 20.5357 12.5006ZM18.75 12.5006C18.75 15.9526 15.952 18.7506 12.5 18.7506C9.04799 18.7506 6.25 15.9526 6.25 12.5006C6.25 9.04856 9.04799 6.25058 12.5 6.25058C15.9503 6.25448 18.7461 9.05024 18.75 12.5006Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25.0006,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockUnSelected);
export default __webpack_public_path__ + "static/media/clockUnSelected.ef3904802e2d241f3536c4bcc2edc584.svg";
export { ForwardRef as ReactComponent };